import Image from '@atlaskit/image';
import lozengeDropDownAnatomyLight from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-anatomy-light.png";
import lozengeDropDownAnatomyDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-anatomy-dark.png";
import lozengeDropdownTriggerDo from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-trigger-do.png";
import lozengeDropdownTriggerDont from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-trigger-dont.png";
import lozengeDropdownTriggerDoDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-do-1-dark.png";
import lozengeDropdownTriggerDontDark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-dont-1-dark.png";
import lozengeDropdownTriggerDo2Light from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-do-2-light.png";
import lozengeDropdownTriggerDo2Dark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-do-2-dark.png";
import lozengeDropdownTriggerDont2Light from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-dont-2-light.png";
import lozengeDropdownTriggerDont2Dark from "../../../../../../packages/design-system/lozenge/constellation/images/lozenge-dropdown-dont-2-dark.png";
import * as React from 'react';
export default {
  Image,
  lozengeDropDownAnatomyLight,
  lozengeDropDownAnatomyDark,
  lozengeDropdownTriggerDo,
  lozengeDropdownTriggerDont,
  lozengeDropdownTriggerDoDark,
  lozengeDropdownTriggerDontDark,
  lozengeDropdownTriggerDo2Light,
  lozengeDropdownTriggerDo2Dark,
  lozengeDropdownTriggerDont2Light,
  lozengeDropdownTriggerDont2Dark,
  React
};